import { render } from "./Forget.vue?vue&type=template&id=37f92767&scoped=true"
import script from "./Forget.vue?vue&type=script&lang=ts"
export * from "./Forget.vue?vue&type=script&lang=ts"

import "./Forget.vue?vue&type=style&index=0&id=37f92767&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37f92767"

export default script